<!-- BOTÓN FLOTANTE -->
@if (chatState === 'closed') {
<button (click)="toggleChat()" class="fixed bottom-5 right-5 z-[9999] w-14 h-14 rounded-full shadow-xl
         bg-gradient-to-r from-primary-500 to-primary-600
         text-white flex items-center justify-center
         hover:scale-110 transition-all duration-300">
  <i class="pi pi-comments text-xl"></i>
</button>
}

<!-- CHAT -->
@if (chatState !== 'closed') {
<div class="fixed z-[9999] flex flex-col overflow-hidden transition-all duration-300
           rounded-2xl border shadow-2xl
           bg-surface-0 dark:bg-surface-900
           border-surface-200 dark:border-surface-700" [class.bottom-5]="chatState === 'open'"
  [class.right-5]="chatState === 'open'" [class.w-[370px]]="chatState === 'open'"
  [class.h-[520px]]="chatState === 'open'" [class.top-0]="chatState === 'maximized'"
  [class.left-0]="chatState === 'maximized'" [class.w-full]="chatState === 'maximized'"
  [class.h-full]="chatState === 'maximized'" [class.rounded-none]="chatState === 'maximized'">

  <!-- HEADER -->
  <div class="flex items-center justify-between px-4 py-3 text-white
             bg-gradient-to-r from-primary-500 to-primary-600">

    <div class="flex items-center gap-2">
      <div class="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center text-lg">
        🤖
      </div>
      <div class="flex flex-col leading-tight">
        <span class="font-semibold">Asistente ChatBot </span>
        <small class="opacity-80">En línea</small>
      </div>
    </div>

    <div class="flex items-center gap-1">

      @if (chatState === 'open') {
      <button class="p-2 hover:bg-white/20 rounded transition" (click)="maximizeChat()">
        <i class="pi pi-window-maximize"></i>
      </button>
      }

      @if (chatState === 'maximized') {
      <button class="p-2 hover:bg-white/20 rounded transition" (click)="minimizeChat()">
        <i class="pi pi-window-minimize"></i>
      </button>
      }

      <button class="p-2 hover:bg-red-500/80 rounded transition" (click)="closeChat()">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <!-- MENSAJES -->
  <div class="flex-1 overflow-y-auto p-4 space-y-3
             bg-surface-50 dark:bg-surface-800" #scrollContainer>

    @for (msg of messages; track $index) {
    <div class="flex" [class.justify-end]="msg.sender === 'user'" [class.justify-start]="msg.sender === 'bot'">

      <div class="px-4 py-2 rounded-2xl max-w-[75%]  shadow-sm" [class.bg-primary-500]="msg.sender === 'user'"
        [class.text-white]="msg.sender === 'user'" [class.bg-surface-0]="msg.sender === 'bot'"
        [class.dark:bg-surface-700]="msg.sender === 'bot'">

        <div [innerHTML]="msg.text"></div>

        @if (msg.options?.length) {
        <div class="flex flex-col gap-1 mt-2 opacity-70">
          @for (opt of msg.options; track $index) {
          <span>👉 {{ opt.id }}. {{ opt.text }}</span>
          }
        </div>
        }

      </div>
    </div>
    }

    @if (loading) {
    <div class="flex justify-start">
      <div class="px-4 py-2 rounded-2xl text-sm shadow-sm
                   bg-surface-0 dark:bg-surface-700 text-color animate-pulse">
        Escribiendo...
      </div>
    </div>
    }

  </div>

  <!-- INPUT -->
  <div class="p-3 border-t flex items-center gap-2
             bg-surface-0 dark:bg-surface-900
             border-surface-200 dark:border-surface-700">

    <input pInputText [(ngModel)]="userInput" (input)="onInputChange($event)" (keyup.enter)="sendMessage()"
      [placeholder]="currentStep === 'ia' 
  ? 'Escribe tu pregunta...' 
  : 'Escribe un número...'" class="flex-1 rounded-full px-4 py-2 text-sm
               bg-surface-100 dark:bg-surface-800
               border border-surface-300 dark:border-surface-600 text-color
               focus:ring-2 focus:ring-primary-400 focus:outline-none" />

    <button class="w-10 h-10 flex items-center justify-center rounded-full
               bg-primary-500 text-white
               hover:bg-primary-600 transition-all" (click)="sendMessage()">
      <i class="pi pi-send"></i>
    </button>

  </div>

</div>
}